import { t } from '@lingui/core/macro';
import { BookingRecordListForCustomer } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge, NoddiBasicCard } from 'noddi-ui-web';
import {
  BookingDetailsTabs,
  customerRoutes,
  formatCurrencyAmount,
  formatLicensePlate,
  NoddiDateFormats,
  noddiFormatDate
} from 'noddi-util';

import { CarManagerNames } from '../../../components/Common/CarManagerNames';

type Props = {
  booking: BookingRecordListForCustomer;
};

export const BookingListItem = ({ booking }: Props) => {
  return (
    <NoddiBasicCard
      className='flex cursor-pointer items-start justify-between gap-4 p-4'
      to={customerRoutes.bookingInfo.getPath({ slug: booking.slug, tab: BookingDetailsTabs.ORDER_DETAILS })}
    >
      <div className='flex flex-1 flex-col gap-3'>
        <NoddiBadge variant='outline' className='flex items-center gap-2'>
          <NoddiIcon name='Calendar' size='small' />
          <p className='text-sm'>{noddiFormatDate(booking.date, NoddiDateFormats.DATE)}</p>
        </NoddiBadge>

        <div className='flex flex-col gap-3'>
          {booking.bookingItemsCar.map((bookingItem, idx) => (
            <div key={idx} className='flex flex-col gap-0.5'>
              <p className='font-semibold'>
                {bookingItem.make} {bookingItem.model}{' '}
                <span className='font-normal'>{formatLicensePlate(bookingItem.licensePlate.number)}</span>
              </p>
              <CarManagerNames carManagers={bookingItem.carManagers} />
              <p className='text-sm text-muted-foreground'>
                {bookingItem.orderLines
                  ?.filter((orderLine) => orderLine.salesItemId != null)
                  .map((orderLine) => orderLine.description)
                  .join(', ')}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className='flex shrink-0 flex-col items-end justify-between gap-1 self-stretch'>
        {booking.completedAt && <PaymentStatusChip booking={booking} />}
        <p className='font-semibold'>{formatCurrencyAmount({ money: booking.order.amountGross })}</p>
      </div>
    </NoddiBasicCard>
  );
};

const PaymentStatusChip = ({ booking }: { booking: BookingRecordListForCustomer }) => {
  if (booking.order.isFullyPaid) {
    return <NoddiBadge variant='success'>{t`Paid`}</NoddiBadge>;
  }
  if (booking.order.isManuallyInvoiced) {
    return <NoddiBadge variant='warning'>{t`Invoiced`}</NoddiBadge>;
  }
  return <NoddiBadge variant='destructive'>{t`Unpaid`}</NoddiBadge>;
};
